import { UserProfile } from '@aibees/shared/features';
import { AccountOverview } from '@aibees/shared/features/user-profile/features/account-overview';
import { EmailNotificationSettings } from '@aibees/shared/features/user-profile/features/email-notification-settings';

export function UserProfileView() {
  return (
    <UserProfile
      config={[
        {
          title: 'Account Overview',
          component: <AccountOverview />,
        },
        {
          title: 'Email Notification Settings',
          component: <EmailNotificationSettings />,
          comingSoon: true,
        },
      ]}
    />
  );
}
